<template>
  <div class="widget-instructions-two">
    <p class="widget-instructions">
      {{ $t("widget_details.step_2") }}
    </p>
    <p>
      {{ $t("widget_details.builder_link1") }}
      <a @click="scrollMeTo('custom_attributes')">{{
        $t("widget_details.builder_link2")
      }}</a
      >{{ $t("widget_details.builder_link3") }}
    </p>
    <br />
    <div class="columns">
      <div class="column is-12">
        <div class="tile is-ancestor">
          <div class="tile is-parent">
            <div class="tile is-child box custom-tile code-demo">
              <div class="header">
                <ButtonCopy class="is-pulled-right is-small"></ButtonCopy>
              </div>
              <div class="instructions-box content">
                <p class="sample-code lorem-code">&nbsp;&lt;body&gt; <br /></p>
                <p class="sample-code lorem-text">
                  &lt;p&gt;Lorem ipsum dolor...&lt;/p&gt;
                </p>
                <br />
                <div ref="text">
                  <p class="sample-code comment-code">
                    &lt;!--
                    {{ $t("widget_details.widget_tag") }} --&gt;
                  </p>
                  <p class="sample-code script-text">
                    &lt;{{ widget.widget_tag }} <br />
                    &nbsp;&nbsp;lang="en"<br />
                  </p>

                  <p class="sample-code comment-code">
                    &nbsp;&nbsp;{{ $t("widget_details.customize_tag") }}
                  </p>

                  <p class="sample-code script-text">
                    &gt;&lt;/{{ widget.widget_tag }}&gt;
                    <br />
                  </p>
                </div>
                <br />
                <p class="sample-code lorem-text">
                  &lt;p&gt;Lorem ipsum dolor...&lt;/p&gt;
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonCopy from "@/components/ButtonCopy.vue";
export default {
  name: "WidgetInstructionsTwo",
  props: {
    widget: { type: Object, required: true }
  },
  data() {
    return {
      toggle: false,
      selectedData: [] // Must be an array reference
    };
  },
  components: {
    ButtonCopy
  },
  methods: {
    scrollMeTo: function(refName) {
      var element = this.$parent.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    }
  }
};
</script>
<style lang="scss">
/* slide animation */
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
p.click_title {
  margin-top: 12px;
  margin-bottom: 8px;
}
.code-demo {
  margin-bottom: 30px;
}
.instructions-box.content {
  padding: 10px;
}
@media screen and (max-width: 416px) {
  .is-pulled-right {
    font-size: 80%;
  }
  .code-demo {
    overflow-wrap: break-word;
  }
}
</style>
